if (!customElements.get('hero-banner-component')) {
  customElements.define(
    'hero-banner-component',
    class HeroBannerComponent extends HTMLElement {
      constructor() {
        super();
        // eslint-disable-next-line radix
        this.milliseconds = parseInt(this.getAttribute('milliseconds'));
        this.activate = this.getAttribute('activate') === 'activate';
        this.initSwiper();
      }

      initSwiper() {
        const swiper = this.querySelector('.my-swiper');
        const slides = swiper.querySelectorAll('.swiper-slide');

        // eslint-disable-next-line no-new, no-undef
        new Swiper(swiper, {
          loop: true,
          slidesPerView: 'auto',
          pagination:
            slides.length > 1
              ? {
                  el: this.querySelector('.swiper-pagination'),
                  dynamicBullets: true,
                  clickable: true,
                }
              : false,
          autoplay: this.activate
            ? {
                delay: this.milliseconds,
              }
            : false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });
      }
    }
  );
}
